import { Category } from '@/domain/models/content/category'
import { Account } from '@/domain/usecases'
import { UserContentSearch } from '@/domain/usecases/content/user-content-search'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import SearchLoader from './search-loader'

export default class CategorySearchLoader extends SearchLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    private readonly categories: Category.Enum[]
  ) {
    super(account, queryClient, ldClient)
  }

  protected createSearchParams(searchParams: URLSearchParams): UserContentSearch.Params {
    const params = super.createSearchParams(searchParams)
    params.categories = this.categories
    return params
  }
}
